import HeaderComp from "./Header";
import HeroBG from "./HeroBG";
import BrandsHome from "./BrandsHome";
import FourColumnsRoundedImg from "./FourColumnsRoundedImg";
import TwoColumnsTextLeft from "./TwoColumnsTextLeft";
import RoundedVideo from "./RoundedVideo";
import TwoColumnsTextRight from "./TwoColumnsTextRight";
import CarouselComp from "./CarouselComp";
import ButtonComp from "./ButtonComp";
import FooterComp from "./FooterComp";
import ThreeColumnsCards from "./ThreeColumnsCards";
import PostList from "./PostList";
import PostDetailComp from "./PostDetailComp";
import Loader from "./Loader";
import TwoColumnsText from "./TwoColumnsText"
import CenterHtml from "./CenterHtml"
import TwoColumnsImage from "./TwoColumnsImage";
import FloatingBanner from "./FloatingBanner";

// 
import Payments from "./Payments"

export { 
    HeaderComp, 
    HeroBG, 
    BrandsHome, 
    FourColumnsRoundedImg, 
    TwoColumnsTextLeft, 
    RoundedVideo, 
    TwoColumnsTextRight, 
    CarouselComp,
    ButtonComp,
    FooterComp,
    ThreeColumnsCards,
    PostList,
    PostDetailComp,
    Loader,
    TwoColumnsText,
    CenterHtml,
    TwoColumnsImage,
    FloatingBanner,
    // 
    Payments
}